import authors from "./authors";
import categories from "./categories";
import files from "./files";
import programs from "./programs";
import works from "./works";

export default {
    authors,
    categories,
    files,
    programs,
    works,
};
